import Vue from 'vue';

import LoadingOverlay from './LoadingOverlay.vue';
Vue.component('LoadingOverlay', LoadingOverlay);

import Avatar from './Avatar.vue';
Vue.component('Avatar', Avatar);

import CardAutocomplete from './CardAutocomplete.vue';
Vue.component('CardAutocomplete', CardAutocomplete);

import VMaskedTextarea from './VMaskedTextarea.vue';
Vue.component('VMaskedTextarea', VMaskedTextarea);

import VMaskedTextField from './VMaskedTextField.vue';
Vue.component('VMaskedTextField', VMaskedTextField);

import FileUploadInput from './FileUploadInput.vue';
Vue.component('FileUploadInput', FileUploadInput);

import SidebarMenuItem from './SidebarMenuItem.vue';
Vue.component('SidebarMenuItem', SidebarMenuItem);

import DynamicField from './DynamicField.vue';
Vue.component('DynamicField', DynamicField);

import DynamicFieldValue from './DynamicFieldValue.vue';
Vue.component('DynamicFieldValue', DynamicFieldValue);

import TitleRow from './TitleRow.vue';
Vue.component('TitleRow', TitleRow);
import TitleRowButton from './TitleRowButton.vue';
Vue.component('TitleRowButton', TitleRowButton);

import MultiSelectLists from './MultiSelectLists.vue';
Vue.component('MultiSelectLists', MultiSelectLists);

import ParkingPenalties from './ParkingPenalties.vue';
import HomeStatCard from './HomeStatCard.vue';
import ColumnSelector from './ColumnSelector.vue';
export {
  ParkingPenalties,
  HomeStatCard,
  ColumnSelector,
};
